<template>
    <region-featured-products-section
        class="region-featured-products-section"
        :title="attributes.regionFeaturedProducts_title"
        :products="mappedProducts"
    />
</template>

<script>
    import RegionFeaturedProductsSection
        from '../../../organisms/RegionFeaturedProductsSection/RegionFeaturedProductsSection.vue';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'region-featured-products-section-module',

        components: { RegionFeaturedProductsSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Format the products for the RegionFeaturedProductsSection.
             *
             * @returns {object}
             */
            mappedProducts() {
                // Use regional products if available, otherwise use product relations
                const regionalProducts = this.attributes.regionFeaturedProducts_regionalProducts;

                if (regionalProducts.length > 0) {
                    return regionalProducts.map((product) => ({
                        name: product.title,
                        calories: product.calories,
                        image: formatMediaObject.call(this, product.product_image),
                    }));
                }

                return (this.attributes.regionFeaturedProducts_products || []).map((product) => ({
                    name: product.marketing_title,
                    calories: product.calories,
                    image: formatMediaObject.call(this, product.website_thumbnail_image),
                    to: product.page?.uri,
                }));
            },
        },
    };
</script>
